import React, { Component } from 'react';
import { Card, Row, Col, Skeleton } from 'antd';
import './CarCard.css';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import ObdServiceButton from '../../ObdServiceButton';
import DTCScanServiceButton from '../../DTCScanServiceButton';

const CarAttribute = props => (
  <Row type="flex" className={`${props.className || ''} CarAttribute`} style={{ ...props.style }} title={props.title}>
    {props.label && (
      <Col>
        <strong className="label">{props.label}</strong>
      </Col>
    )}

    <Col style={{ overflow: 'hidden' }}>
      <div style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>{props.value}</div>
    </Col>
  </Row>
);

const serviceLevelsWithLimitedFeatures = ['light-a'];

@inject('translationsStore', 'commonStore')
@observer
export default class CarCard extends Component {
  render() {
    const { translationsStore, type, makeModel, commonStore, lastInspectionDate, obdService, offer, lastDTCScanResponse } = this.props;
    
    return (
      <Card className="CarCard" style={this.props.style}>
        <Skeleton loading={!this.props.make}>
          <Row type="flex" style={{ justifyContent: 'space-between', flexWrap: 'nowrap' }}>
            <Col style={{ width: '60%' }}>
              <CarAttribute className="title" value={makeModel || ''} title={makeModel || ''} />
              <CarAttribute className="subtitle" value={(type || {}).descrizione} title={(type || {}).descrizione} />
              <CarAttribute value={this.props.imei} label={translationsStore.translate('carView.car.imei')} />
              <CarAttribute value={this.props.casenumber} label={translationsStore.translate('carView.car.casenumber')} />
              {!!obdService && !!offer && !serviceLevelsWithLimitedFeatures.includes(this.props.serviceLevel) && (
                <div className="obdService">
                  <div>{translationsStore.translate('carView.obdservice.label')}: </div>
                  <ObdServiceButton
                    loading={obdService.loading}
                    obdService={obdService}
                    offer={offer.status === 'success' ? offer.name : offer.status}
                    onChange={this.props.onChangeObdService}
                  />
                </div>
              )}
              {!!commonStore.dealer && !!commonStore.dealer.fullScanEnabled && (
                <div className="dtcScanService">
                  <DTCScanServiceButton
                    dtcscanService={lastDTCScanResponse}
                    onLaunchFullScan={this.props.onLaunchDTCFullScan}
                  />
                </div>
              )}
            </Col>
            <Col className="right" style={{ width: '40%', marginLeft: '10px' }}>
              <CarAttribute className="title" value={this.props.plate} />
              <CarAttribute className="subtitle" value="" />
              <CarAttribute value={this.props.registrationYear} label={translationsStore.translate('carView.car.registrationYear')} />
              <CarAttribute value={this.props.alimentation} label={translationsStore.translate('carView.car.alimentation')} />
              <CarAttribute value={this.props.serviceLevel} label={translationsStore.translate('carView.car.serviceLevel')} />
              {!!lastInspectionDate && (
                <CarAttribute value={moment(lastInspectionDate).format(commonStore.longDateFormat.L)} label={translationsStore.translate('carView.car.lastInspectionDate')} />
              )}
            </Col>
          </Row>
        </Skeleton>
      </Card>
    );
  }
}
